import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { listGallery } from "../../server/apihelper";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import SEO from "../../common-components/SEO";
// import "./Gallery.css"; // ✅ Add a CSS file for styles

export const Gallery = () => {
  const [galleryList, setGalleryList] = useState([]);
  const [category, setCategory] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const [contentType, setContentType] = useState("");
  const [imageName, setImageName] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const itemsPerPage = 15;

  useEffect(() => {
    AOS.init();
  }, []);

  //  Fetch gallery data (called whenever category or page changes)
  useEffect(() => {
    const query = `page=${page}&items_per_page=${itemsPerPage}&category=${category}`;
    listGallery(query).then((res) => {
      if (page === 1) {
        setGalleryList(res.data);
      } else {
        setGalleryList((prev) => [...prev, ...res.data]);
      }

      if (!res.data || res.data.length < itemsPerPage) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    });
  }, [category, page]);

  useEffect(() => {
    setPage(1);
    setHasMore(true);
  }, [category]);

  const handleContentClick = (content, type, name) => {
    setSelectedContent(content);
    setContentType(type);
    setImageName(name);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContent(null);
    setContentType("");
    setImageName("");
  };

  return (
    <>
      <style>
        {`
          /* ---------- Gallery Layout ---------- */
          .gallery-grid {
            margin-top: 30px;
          }

          .gallery-card {
            position: relative;
            overflow: hidden;
            border-radius: 12px;
            cursor: pointer;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            transition: transform 0.4s ease, box-shadow 0.3s ease;
          }

          .gallery-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          }

          .gallery-image {
            width: 100%;
            height: 280px;
            object-fit: cover;
            transition: transform 0.5s ease;
            border-radius: 12px;
          }

          .gallery-card:hover .gallery-image {
            transform: scale(1.08);
          }

          .gallery-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 40%;
            background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.75));
            color: #fff;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            padding: 15px;
            opacity: 0;
            transition: opacity 0.4s ease;
          }

          .gallery-card:hover .gallery-overlay {
            opacity: 1;
          }

          .gallery-title {
            font-size: 1rem;
            font-weight: 500;
            text-align: center;
            margin: 0;
          }

          /* ---------- Show More Button ---------- */
          .show-more-btn {
            padding: 10px 30px;
            border-radius: 30px;
            font-weight: 600;
            background: #004aad;
            border: none;
            transition: 0.3s;
            color: white;
          }

          .show-more-btn:hover {
            background: #00347a;
          }

          /* ---------- Responsive ---------- */
          @media (max-width: 768px) {
            .gallery-image {
              height: 220px;
            }
          }

          @media (max-width: 576px) {
            .gallery-image {
              height: 180px;
            }
          }
        `}
      </style>
      <div>
        <SEO
          fullTitle="Architecture College Gallery | Campus Life, Facilities & Student Events"
          description="Architecture college gallery showcasing campus life, state-of-the-art facilities
          , inspiring student events, and academic excellence at McGAN’S"
          keywords="Architecture college gallery, McGAN’S gallery, Campus life in Tamil Nadu, Architecture college photos, Architecture facilities, Student events, Architecture workshops, Nilgiris architecture college images, Top architecture colleges gallery"
          url="https://mcgansarch.com/gallery"
        />
        <h1 style={{ display: "none" }}>
          Gallery of McGAN’S Ooty School of Architecture
        </h1>
      </div>

      <div>
        {/* ✅ Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h3 className="BannerHeader">Gallery</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">Gallery</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Gallery Section */}
        <div className="container py-5">
          <div className="row justify-content-left gallery-grid">
            {galleryList.length > 0 ? (
              galleryList.map((item, index) => (
                <React.Fragment key={index}>
                  {/* ✅ Image Card */}
                  {item.image && (
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4" data-aos="zoom-in">
                      <div
                        className="gallery-card"
                        onClick={() =>
                          handleContentClick(item.image, "image", item.title)
                        }
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          loading="lazy"
                          width={420}
                          height={280}
                          className="gallery-image"
                        />
                        <div className="gallery-overlay">
                          <p className="gallery-title">{item.title}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/*  Video Card */}
                  {item.video && item.video.trim() !== "" && (
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4" data-aos="zoom-in">
                      <div
                        className="gallery-card"
                        onClick={() =>
                          handleContentClick(item.video, "video", item.title)
                        }
                      >
                        <video
                          muted
                          loop
                          autoPlay
                          playsInline
                          className="gallery-image"
                        >
                          <source src={item.video} type="video/mp4" />
                        </video>
                        <div className="gallery-overlay">
                          <p className="gallery-title">{item.title}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))
            ) : (
              <div className="col-12 text-center mt-4">
                <p>No data available</p>
              </div>
            )}
          </div>

          {/*  Show More Button */}
          {hasMore && galleryList.length >= itemsPerPage && (
            <div className="text-center mt-4 mb-4">
              <button
                className="btn show-more-btn"
                style={{ backgroundColor: "#b20d12", border: "none" }}
                onClick={() => setPage((prev) => prev + 1)}
              >
                Show More
              </button>

            </div>
          )}
        </div>
      </div>

      {/* ✅ Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{imageName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {contentType === "image" && (
            <img
              src={selectedContent}
              alt="Selected"
              className="img-fluid w-100"
              width={1200}
              height={800}
              style={{ maxHeight: "80vh", objectFit: "contain" }}
            />
          )}
          {contentType === "video" && (
            <video
              controls
              className="w-100"
              style={{ maxHeight: "80vh", objectFit: "contain" }}
            >
              <source src={selectedContent} type="video/mp4" />
            </video>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
